<style lang="less">
.toptips{
	height: 36px;
	background: #ffe9e9;
	font-size: 12px;
	font-weight: 400;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	padding: 0 16px;
	color: #d33a2a;
	line-height: 18px;
	img{
		width: 16px;
		margin-right: 3px;
	}
	span{
		display: inline-block;
		padding: 3px 0 0 0;
		flex: 1;
		white-space: nowrap;
		/*text-overflow:ellipsis;*/
		overflow: hidden;
		font-size: 12px;
	}
	.operate{
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
		white-space: nowrap;
		text-overflow:ellipsis;
		overflow: hidden;
		font-weight: 700;
		color: #d33a2a;
		font-size: 12px;
		a, span{
			color: #d33a2a;
		}
	}
	.line{
		width: 1px;
		height: 12px;
		display: inline-block;
		background: #eda29c;
		-webkit-box-flex: 0 0 auto; -moz-box-flex: 0 0 auto; -ms-flex: 0 0 auto; flex: 0 0 auto;
		transform: scale(0.6, 1);
		margin: 0 12px;
	}
}
</style>

<template>
	<!-- Main toptips -->
	<div class="toptips">
		<!-- <img src="../assets/note.png"> -->
		<span>{{tips}}</span>
		<template v-if="hasSolt">
			<p class="line"></p>
		</template>
		<div class="operate"><slot></slot></div>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
			};
		},
		computed: {
			hasSolt () {
				return this.$slots.default;
			}
		},
		components: {
		},
		mounted: function () {
		},
		props: {
			tips: {
				type: String,
				default: ''
			}
		},
		methods: {

		}
	};
</script>


// WEBPACK FOOTER //
// src/components/toptips.vue